<template>
  <div>
    <PrimaryButton @click.native="openDialog" class="mb-5" full-width light>
      Add Experience
    </PrimaryButton>
    <AddExperienceDialog v-if="isOpen" @close="closeDialog" />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import AddExperienceDialog from "@/views/profile/QuestionsAndAnswers/steps/Experience/dialogs/AddExperienceDialog";

export default {
  name: "AddExperienceAction",
  components: {
    PrimaryButton,
    AddExperienceDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
